var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getPreorderCommitStatus ? 'confirm-btn' : 'confirm-btn disable',on:{"click":_vm.confirm}},[_c('span',{style:({ opacity: _vm.realnameIsFull || !_vm.getPreorderCommitStatus ? '1' : '0.3' })},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }